import { useController, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import type { CatalogFacility } from '@catalog';
import PreferredFacilitiesField from '../PreferredFacilitiesField';
import StepHeading from '../StepHeading';
import { ConfigurationFormData } from '../formData';

interface Props {
  facilities: CatalogFacility[];
  isLoading: boolean;
}

export default function LocationsStep({ facilities, isLoading }: Props) {
  const intl = useIntl();
  const { control } = useFormContext<ConfigurationFormData>();
  const { field, fieldState } = useController({
    control,
    name: 'preferredFacilities',
    rules: {
      validate: (value) =>
        value.length > 0 ||
        intl.formatMessage({ id: 'accounts.configForm.preferredFacilitiesRequired' }),
    },
  });

  return (
    <PreferredFacilitiesField
      heading={
        <StepHeading
          labelId="accounts.configForm.locationsHeading"
          tooltipId="accounts.configForm.preferredFacilitiesHelp"
          variant="inline"
        />
      }
      isLoading={isLoading}
      facilities={facilities}
      value={field.value}
      onChange={field.onChange}
      error={fieldState.error?.message}
    />
  );
}
